export default __webpack_public_path__ + "static/media/Bosch Software Innovations.a12b9e9d.png";